import React from 'react';
import styles from './topproduct.module.scss';
import { KoCharts, KoImage, KoText, KoTitle } from 'packages';
import  { TopCategoriesChartConfig } from './topcategierschart';
import KoIcon from '@kwapio/icons';

const TopProduct = () => {
  const location=[
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$231'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$281'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$221'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$263'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$869'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$262'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$267'
    }, {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$266'
    }
    ,
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$221'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$263'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$869'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$262'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      location:'Tamil Nadu',
      price:'$267'
    }
  ];

  const product=[
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Earphone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Head Phone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Wireless headset',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Android',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'smart Watch',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'smartphone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'phone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Earphone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Head Phone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Wireless headset',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Android',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Head Phone',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Wireless headset',
      price:'$852'
    },
    {
      image:'.../../../../../../../../../public/images/AppTestingImage.jpg',
      product:'Android',
      price:'$852'
    }

  ];
  const data = [
    { name: "Electronics", value: 1200 },
    { name: "Fashion", value: 800 },
    { name: "Home & Garden", value: 600 },
    { name: "Books", value: 400 },
    { name: "Toys", value: 300 }
  ];

  const withPercentage = "10% ↑ +1,212 today";

  
  const { option, withPercent } = TopCategoriesChartConfig(data, withPercentage);


  return (
    <div className={styles.wrapper}>
      {/* --- Sale by Location --- */}
      <div className={styles.byloaction}>
        <div className={styles.header}>
          <KoTitle level={5} className={styles.title} text="Sale By Location" />
          <KoText text="Sales performance by location" />
        </div>

        <div className={styles.scrollArea}>
          {location.map((item) => (
            <div className={styles.card} key={item.location}>
              <div className={styles.cardContent}>
                <KoImage src={item.image} />
 
                <KoText text={item.location} />
              </div>
              <KoText text={item.price} />

            </div>
          ))}
        </div>
      </div>

      {/* --- Top Product --- */}
      <div className={styles.topProduct}>
        <div className={styles.header}>
          <KoTitle level={5} className={styles.title} text="Top Products" />
          <KoText text="Based on sales" />
        </div>

        <div className={styles.scrollArea}>
          {product.map((item) => (
            <div className={styles.card} key={item.product}>
              <div className={styles.cardContent}>
                <KoImage src={item.image} />

                <KoText text={item.product} />
              </div>
              <KoText text={item.price} />

            </div>
          ))}
        </div>
      </div>

      {/* --- Top Categories --- */}
      <div className={styles.topCategories}>
        <div className={styles.header}>
          <KoTitle level={5} className={styles.title} text="Top Categories" />
          <KoText text="Based on sales" />
          <KoCharts option={option}  />
          <div className={styles.list}>
            {withPercent.map((item) => (
              <div className={styles.listItem} key={item.name}>
                <div className={styles.left}>
                  <span
                    className={styles.dot}
                    style={{ backgroundColor: item.color }}
                  />
                  <span className={styles.name}>{item.name}</span>
                </div>
                <div className={styles.right}>
                  <span className={styles.value}>{item.value.toLocaleString()}</span>
                  <span className={styles.percent}>
                    {item.percent}%{" "}
                    <KoIcon
                      name="ArrowLineUpFilled"
                      height={15}
                      width={15}
                      color="#22c55e"
                    />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>


  );
};

export default TopProduct;